import * as Config from "@/config";
import { BASENAME } from "@/config";
import Forgot from "@/containers/auth/Forgot";
import PasswordChange from "@/containers/auth/PasswordChange";
import BasicInfoDetail from "@/containers/basicInfo/BasicInfoDetail";
import BasicInfoEdit from "@/containers/basicInfo/BasicInfoEdit";
import DrmPfApiDetail from "@/containers/drmPf/DrmPfApiDetail";
import DrmPfDetail from "@/containers/drmPf/DrmPfDetail";
import DrmPfDownload from "@/containers/drmPf/DrmPfDownload";
import MypageTicket, { TicketPageType } from "@/containers/Ticket/Ticket";
import { axios } from "@/lib/axios";
import { useCsrfToken } from "@/hooks/useCsrfToken";
import { useAxiosRouteStore } from "@/stores/axiosRoute";
import { useLoadingStore } from "@/stores/loading";
import { useUserStore } from "@/stores/user";
import { useEffect } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ConfirmModal from "./components/ConfirmModal";
import Header from "./components/Header";
import Login from "./containers/auth/Login";
import { useMessageModalStore } from "./stores/message";

function App() {
  // CSRFトークンの初期化
  const { csrfToken, loading: csrfLoading, error: csrfError } = useCsrfToken();

  useEffect(() => {
    document.title = Config.TITLE;
  }, []);

  // CSRFトークン取得中はローディング表示
  if (csrfLoading) {
    return (
      <div className="uk-position-fixed uk-position-cover uk-flex uk-flex-center uk-flex-middle">
        <div className="uk-position-center">
          <span uk-spinner="ratio: 5"></span>
        </div>
      </div>
    );
  }

  // CSRFトークン取得失敗時もローディング扱い
  if (csrfError || !csrfToken) {
    return (
      <div className="uk-position-fixed uk-position-cover uk-flex uk-flex-center uk-flex-middle">
        <div className="uk-position-center">
          <span uk-spinner="ratio: 5"></span>
        </div>
      </div>
    );
  }

  // TODO: react-router v6対応
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/forgot_login_id"
          element={<Forgot type={Config.Forgot.LoginId} />}
        />
        <Route
          path="/forgot_password"
          element={<Forgot type={Config.Forgot.Password} />}
        />
        <Route path="/password_change" element={<PasswordChange />} />
        <Route path="/basic_info" element={<BasicInfoDetail />} />
        <Route path="/drm_pf/info" element={<DrmPfDetail />} />
        <Route path="/drm_pf/api" element={<DrmPfApiDetail />} />
        <Route path="/drm_pf/download" element={<DrmPfDownload />} />
        <Route path="/basic_info/edit" element={<BasicInfoEdit />} />
        <Route
          path="/ticket"
          element={<MypageTicket isType={TicketPageType.List} />}
        />
        <Route
          path="/ticket/:ticketId"
          element={<MypageTicket isType={TicketPageType.Detail} />}
        />
        <Route
          path="/ticket/new"
          element={<MypageTicket isType={TicketPageType.New} />}
        />
        <Route
          path="/ticket/search"
          element={<MypageTicket isType={TicketPageType.Search} />}
        />
      </Route>
    ),
    {
      basename: BASENAME,
    }
  );

  return <RouterProvider router={router} />;
}

const Layout = () => {
  return (
    <>
      <Loading />
      <Auth />
      <MessageModal />
      <Header />
      <AxiosNavigationHandler />
      <div id="modal-root" />
      <Outlet />
    </>
  );
};

/*
function Auth() {
  const location = useLocation();
  const navigate = useNavigate();
  const setUser = useUserStore((state) => state.setUser);
  const setLoading = useLoadingStore((state) => state.setLoading);
  const setMessage = useMessageModalStore((state) => state.setMessage);

  function getUserData() {
    setLoading(true);
    axios
      .post("/api/v1/customers/getLoginUserInfo", {})
      .then((result) => {
        console.log("wefwefwef", result.data);
        setUser(result.data);
        if (location.pathname === "/login" || location.pathname === "/") {
          navigate("/drm_pf/api");
        }
      })
      .catch((error) => {
        setMessage(Config.MESSAGE_NO_E39);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    // getUserData();
  }, []);

  // 検討: 子コンポーネントに配置して表示切り替え
  return null;
}
  */
function Auth() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useUserStore((state) => [state.user, state.setUser]);
  const setLoading = useLoadingStore((state) => state.setLoading);
  const setMessage = useMessageModalStore((state) => state.setMessage);

  // 認証確認APIを呼ばない公開パスのリスト
  const authCheckSkipPaths = ["/forgot_login_id", "/forgot_password", "/password_change"];

  useEffect(() => {
    // すでにユーザー情報がある場合は取得しない
    if (user) return;

    // パスワード再設定などの公開ページではユーザー情報の取得を行わない
    // （401応答でaxiosのinterceptorが/loginへリダイレクトしてしまうのを防ぐ）
    if (authCheckSkipPaths.includes(location.pathname)) return;

    // ユーザー情報を取得する
    setLoading(true);
    axios
      .post("/api/v1/customers/getLoginUserInfo", {})
      .then((result) => {
        // 成功（ログインしている）
        setUser(result.data);
        // ログイン画面にいたらマイページへ飛ばす
        if (location.pathname === "/login" || location.pathname === "/") {
          navigate("/drm_pf/api");
        }
      })
      .catch((error) => {
        // 失敗（未ログイン or セッション切れ）→ ログイン画面へ
        navigate("/login");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [location.pathname]); // パスが変わるたびにチェックする

  return null;
} 

function Loading() {
  const isLoading = useLoadingStore((state) => state.isLoading);
  return isLoading ? (
    <div
      className="uk-position-fixed uk-position-cover uk-flex uk-flex-center uk-flex-middle"
      style={{ backgroundColor: "rgba(255, 255, 255, 0.5)", zIndex: 1000 }}
    >
      <div className="uk-position-center">
        <span uk-spinner="ratio: 5"></span>
      </div>
    </div>
  ) : null;
}

// axios.tsからuseNavigateが使えないため
function AxiosNavigationHandler() {
  const [axiosRoute, setAxiosRoute] = useAxiosRouteStore((state) => [
    state.axiosRoute,
    state.setAxiosRoute,
  ]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      axiosRoute !== "" &&
      location.pathname !== "/login" &&
      location.pathname !== "/"
    ) {
      navigate("/login");
      setAxiosRoute("");
    }
    return () => {};
  }, [axiosRoute]);

  return null;
}

function MessageModal() {
  const [message, setMessage] = useMessageModalStore((state) => [
    state.message,
    state.setMessage,
  ]);
  return (
    <ConfirmModal
      text={message}
      confirmButtonText="OK"
      isShow={message !== ""}
      onConfirm={() => {
        setMessage("");
      }}
    />
  );
}

export default App;
